module.exports = __webpack_public_path__ + "static/media/personal_service_2.6165222a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/personal_service_2.svg
// module id = 725
// module chunks = 0